import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { MediaService } from './services/media.service';
// import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IdbService } from './services/idb.service';
import { SharedModule } from './shared/shared.module';
import { Media, MediaObject } from '@ionic-native/media/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
// import { IonicStorageModule } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppEnum } from './appenum';
import { sessionInterceptor } from './services/session.interceptor';
import { AppService } from './services/app.service';
// import { GlobalErrorHandler } from './services/global-error-handler';
import { ThemingService } from './services/theming.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomTranslateService } from './services/custom-translate.service';
import { TaskSummaryComponent } from './user-panel/tasks/task-summary/task-summary.component';

import { AppSettings } from './app.settings';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [FormsModule,
        SharedModule,
        IonicStorageModule.forRoot(),
        BrowserModule, IonicModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateService,
            }, isolate: false, extend: true
        }),
        AppRoutingModule,
        NgOtpInputModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            // enabled: environment.production,
            enabled: false,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        BrowserAnimationsModule], providers: [
            AppSettings,
            Title,
            IdbService,
            MediaService,
            Media,
            File,
            FileTransfer,
            AppEnum,
            Geolocation,
            TaskSummaryComponent,
            { provide: HTTP_INTERCEPTORS, useClass: sessionInterceptor, multi: true },
            { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
            {
                provide: APP_INITIALIZER,
                useFactory: (themingService: ThemingService) => () => themingService.initialize(),
                deps: [ThemingService],
                multi: true
            },
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }
